import { render, staticRenderFns } from "./MarkSheetArchiveSheet.vue?vue&type=template&id=5e925700&scoped=true"
import script from "./MarkSheetArchiveSheet.vue?vue&type=script&lang=js"
export * from "./MarkSheetArchiveSheet.vue?vue&type=script&lang=js"
import style0 from "./MarkSheetArchiveSheet.vue?vue&type=style&index=0&id=5e925700&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e925700",
  null
  
)

export default component.exports